import './yotpo-ugc.css';

export default () => {};
